<template>
  <section class="sales-wrap" v-if="!isSpinner">
    <div>
      <Lookup @search="search" :serviceFilters="serviceFilters" />
      <dl v-if="isParams" class="total-money">
        <dt>
          <img src="@/assets/images/icon-money.svg" alt="" /> 총 정산 금액
        </dt>
        <dd>{{ this.total_price | currency }}원</dd>
      </dl>
      <ul class="status-guide">
        <li class="complete">
          <img src="@/assets/images/icon-complete-small.svg" alt="" />
          완료
        </li>
        <li class="refund">
          <img src="@/assets/images/icon-refund-small.svg" alt="" />
          환불
        </li>
        <li class="cancel">
          <img src="@/assets/images/icon-cancel-small.svg" alt="" />
          취소
        </li>
      </ul>
      <sales-list>
        <template slot="table-col">
          <col style="width: 75px" />
          <col style="width: 115px" />
          <col />
          <col />
          <col />
          <col />
          <col />
          <col style="width: 90px" />
          <col />
          <col style="width: 80px" />
        </template>
        <template slot="table-header">
          <th>정산 월</th>
          <th>실적 발생일</th>
          <th>도메인/오피스코드</th>
          <th>서비스</th>
          <th>타입</th>
          <th>사용 건수 A</th>
          <th>결제/환불금액 A</th>
          <th>수수료율 B</th>
          <th><span class="primary-color">정산 금액</span>C=AxB</th>
          <th>상태</th>
        </template>
        <template slot="table-body" v-if="this.salesLists.length === 0">
          <tr>
            <td colspan="10">실적이 없습니다.</td>
          </tr>
        </template>
        <template slot="table-body" v-else>
          <tr v-for="row in salesLists" :key="row.seqno">
            <td>{{ row.calc_date | moment('M') }}월</td>
            <td>{{ row.sales_date }}</td>
            <td :class="row.settle === null ? '' : 'text-left'">
              {{ row.settle === null ? '-' : row.settle.domain }}
            </td>
            <td>{{ row.service_code_nm }}</td>
            <td>{{ row.detail_code_nm }}</td>
            <td class="number">
              <template v-if="row.calc_type === 'A'">
                {{ row.amount | currency }}건
              </template>
              <template v-else>
                -
              </template>
            </td>
            <td class="number">
              <template v-if="row.calc_type === 'A'">
                -
              </template>

              <template v-else> {{ row.price | currency }}원 </template>
            </td>
            <td class="number">
              <template v-if="row.calc_type === 'A'">
                {{ row.calc_percent }}<span class="default-text">원/건</span>
              </template>
              <template v-else>
                {{ row.calc_percent }}<span class="default-text">%</span>
              </template>
            </td>
            <td class="number">
              <!-- <template v-if="row.calc_type === 'A'">
                <span>
                  <b>{{ row.calc_price | currency }}원</b>
                </span>
              </template> -->
              <template>
                <span>
                  <b>{{ row.calc_price | currency }}원</b>
                </span>
              </template>
            </td>
            <td>
              <span v-if="row.status === '1'">
                <img src="@/assets/images/icon-complete.svg" alt="" />
              </span>
              <span v-else-if="row.status === 'R'">
                <img src="@/assets/images/icon-refund.svg" alt="" />
              </span>
              <span v-else>
                <img src="@/assets/images/icon-cancel.svg" alt="" />
              </span>
            </td>
          </tr>
        </template>
        <show-more
          slot="showmore"
          :currentCount="currentCount"
          :totalCount="totalCount"
          @showMore="$_showMore"
          v-show="totalCount > 15 && total_price == 0"
        />

        <ul class="manage-text" slot="contents">
          <li>
            정산 금액은 부가세 포함 금액입니다.
          </li>
        </ul>
      </sales-list>
    </div>
  </section>
  <Spinner :loading="isSpinner" v-else />
</template>

<script>
import _ from 'lodash';
import Lookup from '@/modules/Lookup.vue';
import SalesList from '@/components/Table.vue';
import ShowMore from '@/components/ShowMore.vue';
import Spinner from '@/components/Spinner.vue';
export default {
  filters: {
    currency(value) {
      return parseFloat(value)
        .toFixed(0)
        .replace(/(\d)(?=(\d{3})+(?:\.\d+)?$)/g, '$1,');
    }
  },
  components: {
    Lookup,
    SalesList,
    ShowMore,
    Spinner
  },

  data() {
    return {
      salesLists: [],
      serviceFilters: [],
      search_type: '',
      start_date: '',
      end_date: '',
      current_page: 1,
      totalCount: 0,
      currentCount: 0,
      partner_seq: '',
      partner_user_id: '',
      serviceList: [],
      statusList: [],
      isParams: false,
      isSpinner: false,
      isEmpty: false,
      total_price: 0,

      /**정산관리-정산가능금액*/
      execute_payback_seqno: '',
      execute_parent_seqno: '',
      execute_calc_date: '',
      execute_page: 'Y',
      execute_possible: ''
    };
  },

  mounted() {
    if (this.$route.params.date != undefined) {
      this.isParams = true;
      const dateArr = this.$route.params.date.split('-');

      this.start_date = dateArr[0] + '-' + dateArr[1] + '-01';

      let searchEndDate = new Date(dateArr[0], dateArr[1], 0);
      this.end_date =
        dateArr[0] + '-' + dateArr[1] + '-' + searchEndDate.getDate();

      this.total_price = this.$route.params.total_price;
      this.search_type = 'sales';

      this.execute_parent_seqno = this.$route.params.parent_seqno;
      this.execute_payback_seqno = this.$route.params.payback_seqno;
      this.execute_calc_date = this.$route.params.date;
      if (this.$route.params.type == 'possible') {
        this.execute_possible = 'Y';
      }
    }

    this.$_getSalesData();
    this.$_getServiceFilters();
  },

  methods: {
    //! 실적조회 GET
    $_getSalesData() {
      //this.isSpinner = true;
      let params = {};
      if (this.isParams) {
        params = {
          execute_page: 'Y',
          execute_possible: this.execute_possible,
          execute_payback_seqno: this.execute_payback_seqno,
          execute_parent_seqno: this.execute_parent_seqno,
          execute_calc_date: this.execute_calc_date
        };
      } else {
        params = {
          is_paging: 'Y',
          per_page: '15',
          search_type: this.search_type,
          start_date: this.start_date,
          end_date: this.end_date,
          service_code: this.serviceList,
          detail_code: '',
          status: this.statusList,
          page: this.current_page
        };
      }
      this.axios
        .get('/front/calculateData', { params: params })
        .then(response => {
          if (response.status == 200 || response.status == 204) {
            let data = _.orderBy(response.data.data, ['sales_date'], ['desc']);
            for (const [key, value] of Object.entries(data)) {
              this.salesLists.push(value);
            }

            let pagination = response.data.pagination;

            this.totalCount = pagination.total_count;
            this.currentCount = pagination.per_page * pagination.current_page;
            this.currentCount =
              this.currentCount > this.totalCount
                ? this.totalCount
                : this.currentCount;
            //this.isSpinner = false;
          } else {
            alert(
              '데이터를 가져오는 중 오류가 발생하였습니다.\n잠시 후 다시 시도해주세요.'
            );
            location.replace('/');
          }
        })
        .catch(error => {
          console.log('fetchData failed', error);
        });
    },

    $_getServiceFilters() {
      this.axios
        .get('/front/reseller')
        .then(response => {
          if (response.status == 200) {
            this.serviceFilters = response.data.data[0].default_policy;
          } else {
            alert(
              '데이터를 가져오는 중 오류가 발생하였습니다.\n잠시 후 다시 시도해주세요.'
            );
          }
        })
        .catch(error => {
          console.log('reseller filter failed', error);
        });
    },

    $_showMore(status) {
      //this.current_page += 1;
      if (status == 'init') {
        this.salesLists = [];
        this.current_page = 1;
      } else {
        this.current_page += 1;
      }
      this.$_getSalesData();
    },

    search(params) {
      //let sale_list = [];
      this.serviceList = [];
      this.statusList = [];
      this.search_type = params.search_type;
      this.start_date = params.start_date;
      this.end_date = params.end_date;
      for (let list in params.serviceData) {
        if (params.serviceData[list].checked) {
          this.serviceList.push(params.serviceData[list].value);
        }
      }

      for (let item in params.statusData) {
        if (params.statusData[item].checked) {
          this.statusList.push(params.statusData[item].value);
        }
      }

      this.salesLists = [];
      this.current_page = 1;
      this.isParams = false;
      this.$_getSalesData();
    }
  }
};
</script>

<style lang="scss" scoped>
.reseller-table {
  margin-top: 80px;
  margin-bottom: 10px;

  .manage-text {
    margin-top: 40px;
    margin-bottom: 40px;
    li {
      font-size: 14px;
      color: $text-gray1;

      &::before {
        display: inline-block;
        width: 14px;
        content: '\2022';
      }

      &:not(:last-child) {
        padding-bottom: 10px;
      }
    }
  }
}

.status-guide {
  @include clearfix;
  float: right;
  padding-top: 40px;
  li {
    float: left;
    margin-left: 30px;

    img {
      vertical-align: middle;
      position: relative;
      top: -2px;
    }

    &.complete {
      color: $primary-color;
    }

    &.refund {
      color: $text-refund;
    }

    &.cancel {
      color: $text-gray1;
    }
  }
}

.total-money {
  float: left;
  padding-top: 37px;

  dt,
  dd {
    display: inline-block;
  }

  dt {
    font-size: 20px;
    color: $show-more;
    img {
      position: relative;
      top: -2px;
      vertical-align: middle;
    }
  }

  dd {
    padding-left: 10px;
    color: $primary-color;
    font-size: 20px;
    font-weight: bold;
  }
}
</style>
